import { ObjectHelpers } from "../../helpers/object-helpers";
import { ChartStyleColorModel } from "./chart-style-color.model";

export class ChartStylePIPSettingsModel {
    public selectedChartGradientColor = new ChartStyleColorModel();
    public selectedChartBackgroundColor = new ChartStyleColorModel();
    public selectedDateTextColor = new ChartStyleColorModel();
    public selectedPriceTextColor = new ChartStyleColorModel();
    public selectedUpCandleColor = new ChartStyleColorModel();
    public selectedDownCandleColor = new ChartStyleColorModel();
    public selectedOutlineWickColor = new ChartStyleColorModel();
    public selectedStatusLineTextColor = new ChartStyleColorModel();
    public selectedLineColor = new ChartStyleColorModel();
    public watermarkColor = new ChartStyleColorModel();
    public watermarkOpacity = 34;
    public isGradientChecked = false;
    public isGradientAreaColorChecked = false;
    public isDarkTheme = false;
    
    public timeframeColor: ChartStyleColorModel | null = null;
    public selectedAreaChartUpColor: ChartStyleColorModel | null = null;
    public selectedAreaChartDownColor: ChartStyleColorModel | null = null;

    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
            
            if (data.selectedChartGradientColor) {
                this.selectedChartGradientColor = new ChartStyleColorModel(data.selectedChartGradientColor);
            }

            if (data.selectedChartBackgroundColor) {
                this.selectedChartBackgroundColor = new ChartStyleColorModel(data.selectedChartBackgroundColor);
            }

            if (data.selectedDateTextColor) {
                this.selectedDateTextColor = new ChartStyleColorModel(data.selectedDateTextColor);
            }

            if (data.selectedPriceTextColor) {
                this.selectedPriceTextColor = new ChartStyleColorModel(data.selectedPriceTextColor);
            }

            if (data.selectedUpCandleColor) {
                this.selectedUpCandleColor = new ChartStyleColorModel(data.selectedUpCandleColor);
            }

            if (data.selectedDownCandleColor) {
                this.selectedDownCandleColor = new ChartStyleColorModel(data.selectedDownCandleColor);
            }

            if (data.selectedOutlineWickColor) {
                this.selectedOutlineWickColor = new ChartStyleColorModel(data.selectedOutlineWickColor);
            }
            
            if (data.selectedStatusLineTextColor) {
                this.selectedStatusLineTextColor = new ChartStyleColorModel(data.selectedStatusLineTextColor);
            }
            
            if (data.selectedLineColor) {
                this.selectedLineColor = new ChartStyleColorModel(data.selectedLineColor);
            }
            
            if (data.watermarkColor) {
                this.watermarkColor = new ChartStyleColorModel(data.watermarkColor);
            }
        }
    }
}